import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

const orderActionMap = {
  CANCEL_ORDER: 'Cancel',
  PLACE_ORDER: 'Place',
};
export function orderErrorBuilder({parsedStatusObj}) {
  const { orderAction, reason, quantity, symbol, id } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        {orderAction ? orderActionMap[orderAction] : ''} Order Error[#{id}]:
        {reason ? reason : 'Reason unknown.'}
        {quantity ? '[' + quantity + 'qty.]' : ''}
        {symbol ? '[' + symbol + ']' : ''}
      </Body3>
    </td>
  );
}
